// TODO: use qdata changes
export const getScoreTitle = (value: number): string => {
  let title = '';
  if (value >= 90 && value <= 110) {
    title = 'Perfect';
  }

  if (value < 90) {
    title = 'Danger';
  }

  if (value > 110) {
    title = 'Warning';
  }

  return title;
};

// TODO: use qdata changes
export const getScoreMeaning = (value: number) : string => {
  let scoreMeaning = '';
  if (value >= 90 && value <= 110) {
    scoreMeaning =
      '"Perfect Score!" You are extremely likely to meet your retirement goals while maintaining a great lifestyle!';
  }

  if (value < 90) {
    scoreMeaning =
      '"Below our Comfort Level!" Your goals were not funded.  Let’s look at changing some goals and assumptions.';
  }

  if (value > 110) {
    scoreMeaning =
      '"Above our Comfort Level!"  Yes, you read that right!  This means you will actually leave behind MORE money than you planned and means you are not allowing yourself to live life to the fullest.  Let’s explore bigger goals for you!';
  }

  return scoreMeaning;
};
